export default [
  {
    path: "settings/dns",
    name: "DNS",
    component: () => import("@/views/3pl/Settings/DNS/index"),
  },
  {
    path: "settings/dns/edit-entity",
    name: "EditDNSEntity",
    component: () => import("@/views/3pl/Settings/DNS/EditEntity"),
  },
  {
    path: "settings/dns/reference-settings",
    name: "ReferenceSettings",
    component: () => import("@/views/3pl/Settings/DNS/ReferenceSettings"),
  }
];
